<template>
    <rkm-area
        no-margin-top
        title="Medicamentos"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.medicamentos"
                    hide-filters
                    hide-pagination
                    item-cursor="default"
                >
                    <template v-slot="{item}">
                        <rkm-row>
                            <rkm-col cols="8">
                                <Item
                                    :get-value="() => item.descricaoCompleta"
                                    label="Material"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => item.quantidade"
                                    label="Quantidade"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

// Mixins.
import {formats} from '@/mixins'

export default {
    components: {Item},
    mixins: [formats],
    props: {
        item: {type: Object, required: true},
    },
}
</script>